/**
 * What a child's buddy - a collector card they chose to come along - says
 * after an answer.
 *
 * The same rules as every other line a child reads: never "wrong", never
 * blame, never the answer, short enough to be read (or heard). The lines hold
 * no numbers and no words from a question, so saying one aloud can never give
 * anything away. Checked by the coaching-copy tests in the api.
 */
export const BUDDY_LINES = {
    right: ['Great work!', 'You got it!', 'High five!', 'Brilliant thinking!', 'I knew you could!'],
    tryAgain: [
        "Let's try again together!",
        'Tricky one. We can do it!',
        "I'm right here with you.",
        'Have another go. You can do this!',
    ],
    // The answer has been shown and it is time for the next one: no praise, no
    // fuss, just company.
    moveOn: ['Good try. On to the next one!', "Let's do the next one together.", 'Onwards, team!'],
    // Just chosen. The greeting is how a child who cannot read the button
    // learns what choosing did.
    hello: ["Let's go!", 'Ready for an adventure?', "I'm so happy to come along!"],
};
/** The same line for the same moment, so it does not change on a re-render. */
export function buddyLine(moment, seed) {
    const lines = BUDDY_LINES[moment];
    let hash = 0;
    for (let i = 0; i < seed.length; i += 1)
        hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
    return lines[hash % lines.length];
}
//# sourceMappingURL=buddy.js.map